import {
  getEvent,
  getEventDetail,
  getEventRegistration,
  requestOTPRegistration,
  submitOTPRegistration,
  submitCardNameUser,
  submitNationalIdUser,
  requestFinalizeRegister,
  requestRemoveUser,
} from "api/event";
import { useMutation } from "react-query";

function useGetEvent() {
  return useMutation(getEvent, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useGetEventDetail() {
  return useMutation(getEventDetail, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useGetEventRegistration() {
  return useMutation(getEventRegistration, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useRequestOTPRegistration() {
  return useMutation(requestOTPRegistration, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useSubmitOTPRegistration() {
  return useMutation(submitOTPRegistration, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useSubmitCardNameUser() {
  return useMutation(submitCardNameUser, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useSubmitNationalIdUser() {
  return useMutation(submitNationalIdUser, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useRequestFinalizeRegister() {
  return useMutation(requestFinalizeRegister, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

function useRequestRemoveUser() {
  return useMutation(requestRemoveUser, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

export {
  useGetEvent,
  useGetEventDetail,
  useGetEventRegistration,
  useRequestOTPRegistration,
  useSubmitOTPRegistration,
  useSubmitCardNameUser,
  useSubmitNationalIdUser,
  useRequestFinalizeRegister,
  useRequestRemoveUser,
};
